import { render, staticRenderFns } from "./ScrollSpace.vue?vue&type=template&id=ae75fcb2&"
import script from "./ScrollSpace.vue?vue&type=script&lang=js&"
export * from "./ScrollSpace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports